var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"80","y1":"160","x2":"432","y2":"160","style":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32px"},"key":0}),React.createElement("line",{"x1":"80","y1":"256","x2":"432","y2":"256","style":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32px"},"key":1}),React.createElement("line",{"x1":"80","y1":"352","x2":"432","y2":"352","style":{"strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"32px"},"key":2})]);
}

Menu.defaultProps = {"viewBox":"0 0 512 512","fill":"none","stroke":"currentColor"};

module.exports = Menu;

Menu.default = Menu;
